import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authAPI } from "services/apisService";
import { storeAuthData } from "utils/authUtils";

const SignInComponent = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

const handleSubmit = async (e) => {
  e.preventDefault();
  
  setError("");
  setIsLoading(true);
  
  const trimmedEmail = email.trim();
  const trimmedPassword = password.trim();
  
  if (!trimmedEmail || !trimmedPassword) {
    setError("Email and password are required");
    setIsLoading(false);
    return;
  }
  
  try {
    const authData = await authAPI.login({
      email: trimmedEmail,
      password: trimmedPassword
    });
    
    storeAuthData(authData); 
    
    navigate("/dashboard");
  } catch (err) {
    console.error("Login error:", err);
    const errorMessage =
      err.message === "Failed to fetch"
        ? "Failed to login. Please check your network or server connection."
        : err.message || "Invalid credentials. Please check your email and password.";
    

    setError(() => errorMessage);
    

  } finally {
    setIsLoading(false);
  }
};


  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-12 space-y-8 bg-white rounded-lg shadow-md">
        <div>
          <h1 className="text-3xl font-bold text-center text-gray-900">Sign In</h1>
          <p className="mt-2 text-center text-gray-600">
            Enter your email and password to sign in!
          </p>
        </div>
        
        {error && (
          <div className="p-4 text-red-700 bg-red-100 rounded-md">
            {error}
          </div>
        )}
        
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              Email*
            </label>
            <input
              id="email"
              name="email"
              type="email"
              required
              className="relative block w-full px-3 py-2 mt-1 text-gray-900 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
               
                if (error) {
                 
                }
              }}
            />
          </div>
          
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
              Password*
            </label>
            <input
              id="password"
              name="password"
              type="password"
              required
              className="relative block w-full px-3 py-2 mt-1 text-gray-900 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              placeholder="••••••••"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                if (error) {
                }
              }}
            />
          </div>
          
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <input
                id="remember-me"
                name="remember-me"
                type="checkbox"
                className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                checked={rememberMe}
                onChange={() => setRememberMe(!rememberMe)}
              />
              <label htmlFor="remember-me" className="block ml-2 text-sm text-gray-900">
                Keep me logged in
              </label>
            </div>
            
            <div className="text-sm">
              <a href="/forgot-password" className="font-medium text-[#3985b6] hover:text-[#549fd0]">
                Forgot Password?
              </a>
            </div>
          </div>
          
          <div>
            <button
              type="submit"
              disabled={isLoading}
              className="relative flex justify-center w-full px-4 py-2 text-sm font-medium text-white bg-[#3985b6] border border-transparent rounded-md group hover:bg-[#549fd0] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-blue-400"
            >
              {isLoading ? "Signing in..." : "Sign In"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignInComponent;